export const listOfSections = {
    displayName: "displayName",
    username: "username",
    email: "email",
    otpVerification: "otpVerification",
    dob: "dob",
    whatsAppNumber: "whatsAppNumber",
    whatsAppCountryCode: "whatsAppCountryCode",
    gender: "gender"
} as const